import Trash2 from 'lucide-react/dist/esm/icons/trash-2';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface DeleteConfirmationDialogProps {
  open: boolean;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteConfirmationDialog({
  open,
  deleting,
  onClose,
  onConfirm,
}: DeleteConfirmationDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-red-600 dark:text-red-400">
            מחיקת ביקורת
          </AlertDialogTitle>
          <AlertDialogDescription>פעולה זו אינה ניתנת לביטול</AlertDialogDescription>
        </AlertDialogHeader>

        <div className="px-4 py-4">
          <div className="flex items-center gap-3 rounded-lg border border-red-200 bg-red-50 p-4 dark:border-red-800 dark:bg-red-950/20">
            <div className="flex-shrink-0">
              <Trash2 className="h-5 w-5 text-red-500" />
            </div>
            <div>
              <p className="text-sm font-medium text-red-800 dark:text-red-200">
                האם אתם בטוחים שברצונכם למחוק את הביקורת?
              </p>
              <p className="mt-1 text-xs text-red-600 dark:text-red-300">
                הביקורת וכל התמונות הקשורות אליה יימחקו לצמיתות
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-2 px-4 pb-4">
          <Button
            onClick={onConfirm}
            disabled={deleting}
            className="flex-1 bg-red-600 text-white hover:bg-red-700"
          >
            {deleting ? 'מוחק...' : 'מחק ביקורת'}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={deleting}
            className="flex-1"
          >
            ביטול
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
